export default {
  'inventory_bins.inventory_bin': 'Bin Stock List',
  'inventory_bins.inventory_bin_detail': 'Bin Detail Stock List',
  'inventory_bins.warehouse': 'Warehouse',
  'inventory_bins.product': 'Product',
  'inventory_bins.product_sku': 'SKU',
  'inventory_bins.product_total_qty': 'Total Qty',
  'inventory_bins.warehouse_zone': 'Warehouse Zone',
  'inventory_bins.warehouse_bin': 'Warehouse Bin',
  'inventory_bins.item.no': 'Item No.',
  'inventory_bins.product_name': 'Product Name',
  'inventory_bins.bin_property': 'Bin Property',
  'inventory_bins.on_hand_stock': 'On Hand Qty',
  'inventory_bins.container_box_code': 'Container Box Code',
  'inventory_bins.production_date': 'Production Date',
  'inventory_bins.expiry_date': 'Expiry Date',
  'inventory_bins.split_qty': 'Split Qty',
  'inventory_bins.system_expire_date': 'System Expire Date',
  'inventory_bins.picking_product_type': 'Picking Product Type',
  'inventory_bins.production_batch_code': 'Production Batch Code',
  'inventory_bins.current_bin_stock': 'Total Qty (Without Packed)',
  'inventory_bins.pre_pick_qty': 'PrePick Qty',
  'inventory_bins.pick_qty': 'Pick Qty',
  'inventory_bins.picked_qty': 'Picked Qty',
  'inventory_bins.transaction_code': 'Transaction Code',
  'inventory_bins.create': 'Create Product',
  'inventory_bins.create.fail': 'Fail to create product',
  'inventory_bins.create.success': 'Product has been succesfully created',
  'inventory_bins.update.fail': 'Fail to update product',
  'inventory_bins.update': 'Update',
  'inventory_bins.update.success': 'Product has been succesfully updated',
  'inventory_bins.move-to-bin': 'Move To Other Bin',
  'inventory_bins.move_bin.title': 'Move Bin {warehouse_bin} SKU - {sku}',
  'inventory_bins.split_bin_detail.title': 'Split {container_box_code} SKU - {sku}',
  'inventory_bins.external_warehouse_bin_code': 'External Warehouse Bin Code',
  'inventory_bins.move_qty': 'Move Qty',
  'inventory_bins.move_from_serial_number': 'Move From Serial Number',
  'inventory_bins.move_to_serial_number': 'Move To Serial Number',
  'inventory_bins.merchant': 'Merchant',
  'inventory_bins.move_to_bin_name': 'Move To Bin Name',
  'inventory_bins.can_allocate_stock': 'Available Stock',
  'inventory_bins.inbound_batch_no': 'Internal Batch No.',
  'inventory_bins.asn_code': 'ASN',
  'inventory_bins.available_stock': 'Available Stock',
  'inventory_bins.ean_or_upc_code': 'EAN/UPC Code',
  'inventory_bins.move_bin.leave-confirm': 'Are you sure want to leave this page?',
  'inventory_bins.split-container': 'Split Container',
  'inventory_bins.move-container': 'Move Container',
  'inventory_bins.move_inv_container.title': 'Move Container',
  'inventory_bins.can_move_qty': 'Can Move Qty',
  'inventory_bins.add_move_sku_details': 'Add Require Move Container',
  'inventory_bins.move_container.confirm_bin_title': 'Confirm Move Container',
  'inventory_bins.can_allow_split_stock': 'Can Allow Split Stock',
  'inventory_bins.button.print-split-container': 'Print Container Label',
  'inventory_bins.no_item_warning': 'Please add move items first!',
  'inventory_bins.please-select-item': 'Please select the item',
  'inventory_bins.duplicate-select-item': 'The item has been added before',
  'inventory_bins.show-zero-row': 'Show Row(s) with Zero Qty.',
};
